import { Form, Formik, Field, ErrorMessage } from 'formik';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import * as yup from 'yup'
import { reinitialiserpassword } from '../services/login/ResetPasswordRequest';
import $ from 'jquery';
import { Oval } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';


function MotdepasseOublie() {
    const { t } = useTranslation();
    let [messageErrorReinitialisation, setmessageErrorReinitialisation] = useState("");
    const [loading, setloading] = useState(false)
    const initialValues = {
        username: ""
    }

    const validationSchemaValues = yup.object().shape({
        username: yup.string().email(t('forgotPassword.errors.emailInvalid')).required(t('forgotPassword.errors.emailRequired'))
    });



    const handleOnsubmitReinitialize = (values) => {

        Swal.fire({
            title: t('forgotPassword.confirmTitle'),
            text: t('forgotPassword.confirmText'),
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: t('forgotPassword.cancelButton'),
            confirmButtonColor: '#344b7b',
            cancelButtonColor: '#d33',
            confirmButtonText: t('forgotPassword.confirmButton')
        }).then((result) => {

            if (result.isConfirmed) {
                setloading(true)
                reinitialiserpassword(values).then((res) => {
                    setloading(false)
                    Swal.fire(
                        t('forgotPassword.successTitle'),
                        t('forgotPassword.successMessage'),
                        'success'
                    );
                    setmessageErrorReinitialisation("");

                    $('#fermer').trigger('click');
                }).catch((err) => {
                    setloading(false);
                    setmessageErrorReinitialisation(err.response.data.donnee);
                    console.log(err.response.data);
                })

            }

        })
    }

    return <div className="modal fade" id="mdpOublie" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header blueSkanpay text-white fw-bold">
                    <h5 className="modal-title h4" id="exampleModalLabel">{t('forgotPassword.title')}</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchemaValues}
                    onSubmit={handleOnsubmitReinitialize}
                >
                    {({ resetForm }) => (
                        <Form>
                            <div className="modal-body">
                                <p className='text-danger'>{messageErrorReinitialisation}</p>
                                <div className='mb-3'>
                                    <label htmlFor="username" className='form-label'>{t('forgotPassword.emailLabel')}</label>
                                    <Field type="text" name='username' placeholder={t('forgotPassword.emailPlaceholder')} id="username" className='form-control' />
                                    <p className='text-danger'><ErrorMessage name='username'></ErrorMessage></p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={resetForm} id="fermer" className="btn btn-secondary" data-bs-dismiss="modal">{t('forgotPassword.close')}</button>
                                <Oval width={30} height={30} color="#344b7b" visible={loading} />
                                {!loading && <button type="submit" className="btn blueSkanpay text-white">{t('forgotPassword.submit')}</button>}
                            </div>

                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    </div>
}

export default MotdepasseOublie;
